/* tslint:disable */
/* eslint-disable */
/* @relayHash 0768ab6f6e051ca3eb323f00d38781ef */

import { ConcreteRequest } from "relay-runtime";
export type mutations_UpdateManagerMutationVariables = {
    uuid: string;
    firstName?: string | null;
    lastName?: string | null;
    jobTitle?: string | null;
    email?: string | null;
    telephone?: string | null;
    profileImageToken?: string | null;
};
export type mutations_UpdateManagerMutationResponse = {
    readonly updateManager: {
        readonly firstName: string;
        readonly lastName: string;
        readonly jobTitle: string;
        readonly email: string;
        readonly telephone: string;
        readonly profileImageUrl: string | null;
    } | null;
};
export type mutations_UpdateManagerMutation = {
    readonly response: mutations_UpdateManagerMutationResponse;
    readonly variables: mutations_UpdateManagerMutationVariables;
};



/*
mutation mutations_UpdateManagerMutation(
  $uuid: UUID!
  $firstName: String
  $lastName: String
  $jobTitle: String
  $email: String
  $telephone: String
  $profileImageToken: String
) {
  updateManager(input: {uuid: $uuid, firstName: $firstName, lastName: $lastName, email: $email, jobTitle: $jobTitle, telephone: $telephone, profileImageToken: $profileImageToken}) {
    firstName
    lastName
    jobTitle
    email
    telephone
    profileImageUrl
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "uuid",
            "type": "UUID!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "firstName",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "lastName",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "jobTitle",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "email",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "telephone",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "profileImageToken",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "updateManager",
            "storageKey": null,
            "args": [
                {
                    "kind": "ObjectValue",
                    "name": "input",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "email",
                            "variableName": "email"
                        },
                        {
                            "kind": "Variable",
                            "name": "firstName",
                            "variableName": "firstName"
                        },
                        {
                            "kind": "Variable",
                            "name": "jobTitle",
                            "variableName": "jobTitle"
                        },
                        {
                            "kind": "Variable",
                            "name": "lastName",
                            "variableName": "lastName"
                        },
                        {
                            "kind": "Variable",
                            "name": "profileImageToken",
                            "variableName": "profileImageToken"
                        },
                        {
                            "kind": "Variable",
                            "name": "telephone",
                            "variableName": "telephone"
                        },
                        {
                            "kind": "Variable",
                            "name": "uuid",
                            "variableName": "uuid"
                        }
                    ]
                }
            ],
            "concreteType": "Manager",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "firstName",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lastName",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "jobTitle",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "email",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "telephone",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "profileImageUrl",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "mutations_UpdateManagerMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "mutations_UpdateManagerMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "mutations_UpdateManagerMutation",
            "id": null,
            "text": "mutation mutations_UpdateManagerMutation(\n  $uuid: UUID!\n  $firstName: String\n  $lastName: String\n  $jobTitle: String\n  $email: String\n  $telephone: String\n  $profileImageToken: String\n) {\n  updateManager(input: {uuid: $uuid, firstName: $firstName, lastName: $lastName, email: $email, jobTitle: $jobTitle, telephone: $telephone, profileImageToken: $profileImageToken}) {\n    firstName\n    lastName\n    jobTitle\n    email\n    telephone\n    profileImageUrl\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '7894f35a72bdb2edf4c2a7de444a9da7';
export default node;
